import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import useProcessData from "../../../CommonFunction/ProcessData";
import { Loading, LoadTable } from "../../Components";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import { useDispatch } from "react-redux";

const queryFunction = (fields) => {
  const query = gql`
    query GetAllSalesBill($stockItemId: ID, $voucherType: String, $itemValue: BigInt) {
      GetAllSalesBill(Stock_Item_Id: $stockItemId, Voucher_Type: $voucherType, Item_Value: $itemValue) {
        _id
        ${fields.join(" ")}
      }
    }
  `;
  return query;
};

const SalesReportVoucherEntries = () => {
  const [formData, setFormData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const dispatch = useDispatch();

  const { id, itemValue, voucherType } = location.state?.requestData;
  const { From_Date, To_Date } = location.state?.dateFilter;

  const Key = "Sales_Report_Voucher_Entries";

  const config = useMemo(
    () => ({
      dataKey: "GetAllSalesBill",
      dateKeys: ["Date"],
      deleteKeys: ["__typename"],
    }),
    []
  );

  useEffect(() => {
    if (From_Date && To_Date) {
      console.log(From_Date, To_Date, "From_DateFrom_DateFrom_DateFrom_Date")
      dispatch({
        type: "SET_SELECTED_DATE",
        payload: { FromDate: From_Date, ToDate: To_Date },
      });
      sessionStorage.setItem("SelectedFromDate", JSON.stringify(From_Date));
      sessionStorage.setItem("SelectedToDate", JSON.stringify(To_Date));
    }
  }, [])

  const [fetchLedgerData, { loading: queryLoading, error, data }] = useLazyQuery(queryFunction([]), {
    variables: {
      stockItemId: id,
      itemValue: itemValue,
      voucherType: voucherType,
    },
    fetchPolicy: "network-only", 
    onCompleted: () => {
      setIsLoading(false);
    },
    onError: () => {
      setIsLoading(false);
    },
  });

  const { TableHeaders } = useFetchTableData(queryFunction, fetchLedgerData, setIsLoading, Key);

  const { loading: processDataLoading } = useProcessData(data, setFormData, config, error, formData);
  const isLoading1 = processDataLoading || isLoading;

  return (
    <>
      <HeaderDiv title="Sales Report Voucher Entries" MoreActions={{ Is_Add: false, Is_Edit: false, Is_Delete: false, Is_View: false, Is_Back: true }} />
      {isLoading1 || queryLoading ? (
        <Loading />
      ) : formData.length === 0 ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {queryLoading && <div className="loader-line-div" />}
          <LoadTable data={formData} loading={isLoading1} error={error} title={Key} TableHeaders={TableHeaders} />
        </>
      )}
    </>
  );
};

export default SalesReportVoucherEntries;
